import 'rxjs/add/operator/do';
import { environment } from '../../../environments/environment';
/**
 * Interceptor that adds the authentication header to request
 */
var RouteInterceptor = (function () {
    function RouteInterceptor() {
    }
    /**
     * Intercepts the request and adds the authentication header
     * @param {HttpRequest<any>} req Request
     * @param {HttpHandler}      next HttpHandler
     * @returns {Observable<HttpEvent<any>>} Observable<HttpEvent<any>>
     */
    RouteInterceptor.prototype.intercept = function (req, next) {
        if (req.url.charAt(0) === '$') {
            // Add backend url and remove '$' sign
            var routeReq = req.clone({
                url: environment.backendUrl + 'api/' + req.url.substring(1),
            });
            return next.handle(routeReq);
        }
        // If it's another request (like i18n-JSON) pass original request
        return next.handle(req);
    };
    return RouteInterceptor;
}());
export { RouteInterceptor };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/services/route.interceptor.ts.pre-build-optimizer.js